export default "__VITE_ASSET__Cr5k8nsw__"